// extracted by mini-css-extract-plugin
module.exports = {"Background":"Background_Background__B0tdY"};